// CKEditor  - Rock-solid, free WYSIWYG editor with collaborative editing, 200+ features, full documentation and support: https://ckeditor.com/

// CKEditor Classic
window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic/build/ckeditor.js');
